import styled from 'styled-components';

export const InitialsWrapper = styled.div`
  font-size: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
  border-radius: 50%;

  position: absolute;
  left: 14px;
  top: 15px;
`;
